module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/observable/from"
// module id = 8
// module chunks = 0